// extracted by mini-css-extract-plugin
module.exports = {"root":"FourOFour_root__OfQvr","wrapper":"FourOFour_wrapper__133T9","buttonGroup":"FourOFour_buttonGroup__3zqQB","header":"FourOFour_header__1W9Zy"};